var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclude2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H4ZM15.7944 6.60745C16.1298 6.16874 16.0462 5.54113 15.6075 5.20564C15.1687 4.87016 14.5411 4.95384 14.2056 5.39255L8.49329 12.8625L5.78935 9.38606C5.45028 8.95011 4.82201 8.87158 4.38606 9.21065C3.95011 9.54972 3.87158 10.178 4.21065 10.6139L7.71065 15.1139C7.90099 15.3587 8.19407 15.5013 8.5041 15.5C8.81413 15.4987 9.10603 15.3537 9.29436 15.1075L15.7944 6.60745Z",
    fill: "#7161ba"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclude2);
export default __webpack_public_path__ + "static/media/exclude2.ab0a6d5d77426c177dd29ccfdebf47ea.svg";
export { ForwardRef as ReactComponent };